import React, { createContext, useContext, useRef } from 'react';
const EventEmitterContext = createContext();
export const EventEmitterProvider = ({ children }) => {
  const eventListeners = useRef({});

  const subscribe = (eventName, callback) => {
    if (!eventListeners.current[eventName]) {
      eventListeners.current[eventName] = [];
    }
    eventListeners.current[eventName].push(callback);

    return () => {
      eventListeners.current[eventName] = eventListeners.current[eventName].filter(
        (listener) => listener !== callback
      );
    };
  };

  const emit = (eventName, ...args) => {
    const listeners = eventListeners.current[eventName] || [];
    listeners.forEach((listener) => listener(...args));
  };  

  const value = {
    subscribe,
    emit,
  };

  return (
    <EventEmitterContext.Provider value={value}>
      {children}
    </EventEmitterContext.Provider>
  );
};

export const useEventEmitter = () => {
  const context = useContext(EventEmitterContext);
  if (!context) {
    throw new Error('useEventEmitter must be used within an EventEmitterProvider');
  }
  return context;
};
